module.exports = __webpack_public_path__ + "img/travel.173680fd.svg";